import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Translation
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpBackend,
} from '@angular/common/http';
import {
  MsalModule,
  MsalInterceptor,
  MsalService,
  MsalInterceptorConfiguration,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';

import { Configuration } from 'msal';
import { ComponentsModule } from './components/components.module';
import { MaterialModule } from './components/material.module';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DialogOverviewComponent } from './components/dialog-overview/dialog-overview.component';
import { GLOBAL_CONFIG } from './@core/data/globalConfig';
import { DialogOverviewDeleteOrganizationComponent } from './components/dialog-overview-delete-organization/dialog-overview-delete-organization.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;


// This is the scope for which acccess tokens for calls to the backend API will be requested

// This map contains all resources that will trigger the acquisition
// of access tokens for the given scope(s)


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
  protectedResourceMap.set(GLOBAL_CONFIG.config.backendHost, [GLOBAL_CONFIG.config.apiScope, 'user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}
const redirect = encodeURI(GLOBAL_CONFIG.config.redirectUri);

// Configure AAD authentication parameters

export function MSALConfigFactory(): IPublicClientApplication  {
  return new PublicClientApplication({
    auth: {
      clientId: GLOBAL_CONFIG.config.clientId,
      authority: GLOBAL_CONFIG.config.backendOAuth,
      redirectUri: redirect,
      postLogoutRedirectUri: redirect,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loadFrameTimeout: 10000,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { interactionType: InteractionType.Redirect };
}

export function HttpLoaderFactory(handler: HttpBackend) {
  const http = new HttpClient(handler);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, NotFoundComponent, DialogOverviewComponent, DialogOverviewDeleteOrganizationComponent],
  entryComponents: [NotFoundComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    ComponentsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    MsalModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALConfigFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
